function validateEmail(email) {
  const res = /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return res.test(String(email).toLowerCase());
}

const handleFocus = (event) => event.target.select();

module.exports = { validateEmail, handleFocus }